<template>
  <v-app>
    <v-main class="dark-color">
      <router-view />
    </v-main>
  </v-app>
</template>

<script setup></script>

<style scoped>
.v-application {
  overflow-y: hidden;
}
</style>
